// import {
//     ASYNC_FETCH,
//     ASYNC_FETCH_SUCCESS,
//     ASYNC_FETCH_FAILURE,
//     ASYNC_FETCH_INVALIDATE,
//     SHOW_VIDEO_CHAT_ASSIST,
//   } from './constants';

// import { initial } from "lodash";

const initialState = {
  callPollCount: 0,
  showVideoChatAssist: false,
};


const videoChat = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_VIDEO_CHAT_ASSIST':
      return {
        ...state,
        showVideoChatAssist: action.response,
        callPollCount: action.pollCount,
      };
    default:
      return state;
  }
};

export default videoChat;
